import React from 'react';
import { inject } from 'mobx-react';
import moment from 'moment';

import Container from './Container';
import Pickup from './Pickup';
import SubNotice from './SubNotice';
import Brand from './Brand';

export default inject('page')(({ page }) => (
  <Container>
    <Brand>{`${page.shipping_quote.brand} ${page.shipping_quote.isSameDay ? 'Same-Day' : 'Standard'}`}</Brand>
    {page.shipping_quote.isSameDay ? (
      <Pickup>
        <div>Estimated pick-up:</div>
        <div>{moment(page.shipping_quote.estPickupTime).format('dddd, MMMM Do YYYY, h:mm a')}</div>
      </Pickup>
    ) : (
      <SubNotice>You will need to drop the item off at your nearest {page.shipping_quote.brand} location.</SubNotice>
    )}
  </Container>
));
